module.exports = __webpack_public_path__ + "static/media/Metropolis SemiBold-01.d227671f.svg";